import { createContext } from 'react';
export const LucidDevToolsContext = createContext(null);
